export default "__VITE_ASSET__DBw1h6xX__"